<template>
  <div
    class="flex flex-col pt-10 pb-6 md:py-20 bg-stone-50"
    :class="[twMerge(content?.background === 'dark' && 'bg-teal-900')]"
  >
    <div class="max-w-screen-xl m-auto px-4">
      <h2
        class="my-2"
        :class="[twMerge(content?.background === 'dark' && 'text-stone-50')]"
      >
        {{ content?.title }}
      </h2>
      <h6 class="mb-6 mb-12 text-stone-700">{{ content?.subtitle }}</h6>
      <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div
          v-for="item in content.items"
          :key="item?.id"
          class="p-4 rounded-xl bg-white flex flex-col justify-between"
          :class="[
            twMerge(
              item?.alignment === 'center' &&
                'flex flex-col justify-center items-center'
            ),
          ]"
        >
          <div :class="[twMerge()]">
            <ReviewRatingStars :average-rating="item?.rating" />
            <vue-markdown
              v-if="item?.content"
              class="prose my-5 leading-5"
              :class="[
                item?.alignment === 'center' && 'text-center',
                item?.background === 'dark' && 'text-stone-50',
              ]"
              :source="item?.content || ''"
            ></vue-markdown>
          </div>
          <div>
            <span>{{ item?.author }}</span>
            <span v-if="item?.date">, </span>
            <span>{{ item?.date }}</span>
          </div>
          <NuxtLink :to="item?.CTA?.[0]?.url" class="block hover:text-primary">
            {{ item?.CTA?.[0]?.label }}
          </NuxtLink>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import VueMarkdown from 'vue-markdown-render'
import { twMerge } from 'tailwind-merge'
const { content = {} } = defineProps<{ content: any }>()
</script>
<style lang="postcss" scoped>
:deep(.prose) strong {
  color: white;
}
</style>
